import React from "react";

import ResolutionElementPicker from "./ResolutionElementPicker";
import ResolutionActivityPicker from "./ResolutionActivityPicker";
import ResolutionEdit from "./ResolutionEdit";

export default class ResolutionDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      editMode: false,
      isLoading: true,
    };
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          this.refreshPage();
        },
      );
    } else {
      this.refreshPage();
    }
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params?.args;
    } else {
      return this.controller.state.screenArgs?.args?.args;
    }
  }

  refreshPage = async () => {
    const { goal } = this.getArgs() || {};

    if (!goal) {
      this.controller.changePage("rn:resolution");
      return;
    }

    this.setState((state) => ({
      ...state,
      editMode: !!goal.resolution_id || goal.target_id,
      isLoading: false,
      goal,
    }));
  };

  onPressElement = () => {
    this.setState((state) => ({
      ...state,
      editMode: false,
    }));
  };

  onElementSelected = (element, elementType = "element") => {
    const showTutorials = this.controller?.state?.showTutorials;
    if (showTutorials && !element.isHighlighted) return;

    const { goal } = this.state;
    this.setState((state) => ({
      ...state,
      editMode: true,
      goal: {
        ...goal,
        target_id: element.id,
        id_element: element.id,
        target_name: element.name,
        target_type: elementType,
        target_emoji: element.icon,
      },
    }));
  };

  render() {
    const { isLoading, editMode, goal } = this.state;

    return (
      <>
        {editMode ? (
          <ResolutionEdit
            goal={goal}
            controller={this.controller}
            onPressElement={this.onPressElement}
          />
        ) : !isLoading ? (
          <ResolutionElementPicker
            controller={this.controller}
            onElementSelected={this.onElementSelected}
          />
        ) : null}
      </>
    );
  }
}
